"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgVegetarian = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.896 17.594c1.982-3.365 3.287-8.124 4.075-13.067a2.167 2.167 0 0 0-2.499-2.498c-4.938.787-9.701 2.093-13.066 4.075C1.423 9.039.412 13.147 4.689 17.898l-2.381 2.38a1 1 0 1 0 1.413 1.414l2.381-2.381c4.75 4.277 8.859 3.266 11.794-1.717Zm-10.38.303c3.701 3.318 6.355 2.593 8.658-1.317 1.82-3.091 3.072-7.656 3.824-12.366.022-.143-.069-.234-.211-.212-4.708.75-9.276 2.003-12.367 3.824-3.91 2.303-4.635 4.957-1.317 8.658l1.908-1.908v-3.583a1 1 0 1 1 1.998 0v1.585l1.999-1.999V8.995a1 1 0 1 1 1.998 0v.999h1a1 1 0 0 1 0 1.998H13.42l-1.999 1.999h1.585a1 1 0 0 1 0 1.998H9.424l-1.908 1.908Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgVegetarian);
//# sourceMappingURL=SvgVegetarian.js.map